import { APP_VERSION_STORAGE_KEY } from "./constants";

/**
 * Compare /version.json to stored version; reload when deploy changes (payout-app pattern).
 */
export async function appVersionCheck() {
  try {
    const stored = localStorage.getItem(APP_VERSION_STORAGE_KEY);
    const response = await fetch(`${window.location.origin}/version.json`, {
      cache: "no-store",
      credentials: "same-origin",
    });
    if (!response.ok) {
      return;
    }
    const { version } = await response.json();
    if (!version) {
      return;
    }
    const current = String(version).trim();
    if (!stored) {
      localStorage.setItem(APP_VERSION_STORAGE_KEY, current);
      return;
    }
    if (stored !== current) {
      localStorage.setItem(APP_VERSION_STORAGE_KEY, current);
      window.location.reload();
    }
  } catch (err) {
    console.debug("[obs] appVersionCheck failed", err);
  }
}
